import React from 'react'
import Login from '../anon/Login.js'

export const Welcome = () => (
    <div>
        <div className="jumbotron">
            <h1>Welcome to Blaze</h1>
            <p>Blaze is a companion tool for Truebyte's bespoke-built websites. Want to know more? Why not have at look at our <a href="https://www.truebyte.co.uk">main site?</a></p>
            </div>
        <Login />
    </div>
)